import { getDialogStyles } from "../../../_training.styles";
import { ReviewSection } from "../../../Training.types";

const ReviewSectionHeader = ({ name }: { name: ReviewSection }) => {
  const { classes } = getDialogStyles();

  return <a id={name} className={classes.visuallyHidden} />;
};

export default ReviewSectionHeader;
